
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import Dashboard from '@/components/Dashboard';
import { useAuthCheck } from '@/components/tracks/useAuthCheck';
import { useToast } from '@/components/ui/use-toast';

const DashboardPage: React.FC = () => {
  const location = useLocation();
  const { isLoading } = useAuthCheck();
  const { toast } = useToast();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow pt-24 pb-20">
        <div className="container px-4 mx-auto">
          <div className="w-full max-w-4xl mx-auto">
            <Dashboard />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default DashboardPage;
